import { combineReducers } from 'redux';
import adminReducer from './adminSlice'; // Import the admin reducer
import newsReducer from './newsSlice';
import rjSlice from './rjSlice';
import adsSlice from './adsSlice';
import eventsReducer from "./eventsSlice";


const rootReducer = combineReducers({
  admin: adminReducer, // Combine admin reducer
  news: newsReducer,
  rj:rjSlice,
  ads: adsSlice,
  events: eventsReducer,
  // Add other reducers if needed
});

export default rootReducer;
